function scrolling() {
    const backToTop = document.getElementById('back-to-top');
    let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
    let windowHeightHalf = window.innerHeight / 2;

    if ( currentScroll >= windowHeightHalf) {
        backToTop.classList.add('active');
    } else {
        backToTop.classList.remove('active');
    }
}

document.addEventListener('change', function(event) {
    if (event.target.classList.contains('bundle-select') ) {
        let target = event.target;
        let image = target.options[target.selectedIndex].dataset.image;
        // let price = target.options[target.selectedIndex].dataset.price;
        
        target.closest('.bundle-item').querySelector('img').src = image;
    }
})

document.querySelector('#back-to-top').addEventListener('click', function () {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
});

document.addEventListener("DOMContentLoaded", function(event) {

    let topHeight = document.querySelector('.header-wrapper').offsetHeight + 20;


    if ( document.querySelector('.product__media-wrapper .product__column-sticky') ) {
        document.querySelector('.product__media-wrapper .product__column-sticky').style.top = topHeight + 'px';

        document.querySelector('.product--thumbnail slider-component:last-of-type').style.maxHeight = 
        parseInt(window.innerHeight) - parseInt(document.querySelector('.header-wrapper').offsetHeight) - parseInt(120) + 'px';
    }

    const megaMenu = document.querySelectorAll('.mega-menu');
    const megaMenuContent = document.querySelectorAll('.mega-menu__content');
    const headerMenuItem = document.querySelectorAll('.header__menu-item');
    
    for (var x = 0; x < megaMenu.length; x++ ) {
        megaMenu[x].addEventListener('mouseover', function (e) {
            this.setAttribute('open',''); 
        });
    }
    
    for (var x = 0; x < megaMenuContent.length; x++ ) {
        megaMenuContent[x].addEventListener('mouseout', function (e) {
            this.closest('.mega-menu').removeAttribute('open','');
        });
    }

    for (var x = 0; x < headerMenuItem.length; x++ ) {
        headerMenuItem[x].addEventListener('mouseover', function (e) {
            for (var i = 0; i < megaMenu.length; i++ ) {
                megaMenu[i].removeAttribute('open','');
            }
        });
    }

    const tabArrow = document.querySelectorAll('.tab-arrow');
    const tabContent = document.querySelectorAll('.tab-content');

    for(var x = 0; x < tabArrow.length; x++) {
        tabArrow[x].addEventListener('click', (e) => {
            let index = e.target.dataset.index;

            // hide all
            for(var t = 0; t < tabContent.length; t++) {
                tabContent[t].classList.remove('active');
            }
            
            document.querySelector(`.tab-button[data-index="${index}"`).classList.add('active');
            document.querySelector(`.tab-content[data-index="${index}"`).classList.add('active');

            if ( document.querySelector(`.tab-button[data-index="${parseInt(index) + parseInt(1)}"`) ) {
                document.querySelector(`.tab-button[data-index="${parseInt(index) + parseInt(1)}"`).classList.remove('active');
            }
        })
    }

    const categoryButton = document.querySelectorAll('.category-button');
    const categoryGroup = document.querySelectorAll('.category-group');
    const categoryTabNavButton = document.querySelectorAll('.category-tab_nav-button');
    const categoryTabContent = document.querySelectorAll('.category-tab_content');

    for(var x = 0; x < categoryButton.length; x++) {
        categoryButton[x].addEventListener('click', function (e) {
            let group = e.target.dataset.group;

            for(var y = 0; y < categoryButton.length; y++) {
                categoryButton[y].closest('li').classList.remove('active');
            }

            for(var z = 0; z < categoryGroup.length; z++) {
                categoryGroup[z].classList.remove('active');
            }

            for(var b = 0; b < categoryTabNavButton.length; b++) {
                categoryTabNavButton[b].closest('li').classList.remove('active');
            }
            
            for(var a = 0; a < categoryTabContent.length; a++) {
                categoryTabContent[a].classList.remove('active');
            }

            e.target.closest('li').classList.add('active');

            document.querySelector('.category-group[data-group="' + group + '"').classList.add('active');

            document.querySelector('.category-group[data-group="' + group + '"').querySelector('.category-tab_nav li:first-child').classList.add('active');

            document.querySelector('.category-group[data-group="' + group + '"').querySelector('.category-tab_content:first-child').classList.add('active');

        });
    }

    
    for(var x = 0; x < categoryTabNavButton.length; x++) {

        categoryTabNavButton[x].addEventListener('click', function (e) {
            let tab = e.target.dataset.tab;

            for(var z = 0; z < categoryTabNavButton.length; z++) {
                categoryTabNavButton[z].closest('li').classList.remove('active');
            }
            
            for(var y = 0; y < categoryTabContent.length; y++) {
                categoryTabContent[y].classList.remove('active');
            }

            e.target.closest('li').classList.add('active');
            document.querySelector('.category-tab_content[data-tab="' + tab + '"').classList.add('active');
        })
    }

    if(typeof giftCards  !==  "undefined") {
        if ( giftCards.length > 0 ) {
            let html = '';
            let active = '';
            giftCards.forEach( (card, index) => {
                
                if ( giftOptions.includes(card.group) ) {
                    active = 'active';
                }

                html += `
                <div class="gift-card-design ${active}" data-group="${card.group}">
                    <input id="for-${index}" type="radio" name="properties[Gift Card Design]" value="${card.option}" />
                    <label for="for-${index}">
                        <img src="${card.image}" />
                    </label>
                </div>`;

                active = '';
            });

            const renderGiftCards = document.querySelector('#renderGiftCards');
            const giftCardDesigns = document.querySelector('#giftCardDesign');

            if ( renderGiftCards ) {
                giftCardDesigns.classList.remove('hidden');
                renderGiftCards.innerHTML = html;
            }
        }
    }

    const textCounter = this.querySelector('.text-counter');

    if ( textCounter ) {
        textCounter.querySelector('textarea').onkeyup = function () {

            textCounter.querySelector('.counter').innerHTML = "Characters left: " + ( parseInt(300) - parseInt(this.value.length));
        };
    }

    const COUNTRY = Shopify.country;

    document.querySelectorAll(`[data-country="${COUNTRY}"]`).forEach( element => {
        element.style.display = 'block';
    })
});

window.addEventListener('scroll', function (e) {
    scrolling();
});

window.addEventListener('DOMContentLoaded', () => {
    // jQuery( "#DeliveryTime" ).datepicker({
    //     minDate: themeSettings.pickup_date_min,
    //     maxDate: 60,
    //     beforeShowDay: function(date)
    //     {
    //         var string = jQuery.datepicker.formatDate('mm/dd/yy', date);
    //         return [themeSettings.disable_dates.indexOf(string) == -1];
    //     },
    //     dateFormat: "yy-mm-dd"
    // });

    // jQuery( "#DeliveryTimeCart" ).datepicker({
    //     minDate: themeSettings.pickup_date_min,
    //     maxDate: 60,
    //     beforeShowDay: function(date)
    //     {
    //         var string = jQuery.datepicker.formatDate('mm/dd/yy', date);
    //         return [themeSettings.disable_dates.indexOf(string) == -1];
    //     },
    //     dateFormat: "yy-mm-dd"
    // });

    jQuery( "#RegisterForm-BirthDay" ).datepicker({
        yearRange: '1960:',
        dateFormat: "yy-mm-dd",
        changeMonth: true, 
        changeYear: true, 
    });
});


// Utility functions
const randomString = length => {
  return Array.from(Array(length), () => Math.floor(Math.random() * 36).toString(36)).join('');
}

class Bundle extends HTMLElement {
    constructor() {
        super();
        
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.init();
    }

    init() {

        this.selectedFilter = [];
        
        this.submitBtn = this.querySelector('button#add-to-cart');

        this.quantity = this.querySelector('.quantity__input');

        if (this.submitBtn ) {
            this.submitBtn.addEventListener('click', () => {
                this.querySelector('.loading__spinner').classList.remove('hidden');
                this.AddToCart();
            });
        }

        this.addToBoxBtn = this.querySelectorAll('button.add-to-box');

        for (var x = 0; x < this.addToBoxBtn.length; x++) {
            this.addToBoxBtn[x].addEventListener('click', (e) => {
                this.addToBox(e.target);
            });
        }

        this.filterTheBox = this.querySelectorAll('button.filter-the-box');

        this.filterTheBox.forEach(filterOption => {
            filterOption.addEventListener('click', (e) => {
                this.addFilter(e.target);
            })
        })
        
        this.removeBtn = this.querySelectorAll('.bundle-remove');

        this.removeBtn.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.target.closest('.cart-item').querySelector('.loading__spinner').classList.remove('hidden'); 
                this.removeFromCart(e.target.dataset.bundleKeys);
            })
        });

        this.summarizedItem = [];
    }

    addFilter(target) {

        this.selectedFilter.push(target.dataset.filter);

        let bundleItem = document.querySelectorAll(`.bundle-item`);
        let itemFilter = '';
        let removeLastComma;
        let removeIndex;

        if ( target.classList.contains('remove-from-box') ) {
            target.classList.remove('remove-from-box');
            target.closest('.bundle-filter').classList.remove('active');

            bundleItem.forEach(item => {
                // hide reset
                item.classList.remove('show');

                // remove filter item in array
                removeIndex = this.selectedFilter.indexOf(target.dataset.filter);

                if (removeIndex >= 0) {
                    this.selectedFilter.splice( removeIndex, 1 );
                }
            });
        } else {
            target.classList.add('remove-from-box');
            target.closest('.bundle-filter').classList.add('active');

            bundleItem.forEach(item => {
                removeLastComma = item.dataset.filter.slice(0,-1);
                itemFilter = removeLastComma.split(',');
                
                itemFilter.forEach(filter => {
                    if (this.selectedFilter.includes( filter ) ) {
                        item.classList.add('show');
                    }
                })
            });
        }

        let minimum = parseInt(target.closest('.tab-content').dataset.minimum);
        
        if ( minimum == 0 ) {
            target.closest('.tab-content').querySelector('.tab-arrow_next').disabled = false;
            target.closest('.tab-content').querySelector('.tab-arrow_next').classList.remove('disabled');
        } else {
            if ( target.closest('.tab-content').querySelectorAll('.bundle-filter.active').length >= minimum) {
                target.closest('.tab-content').querySelector('.tab-arrow_next').disabled = false;
                target.closest('.tab-content').querySelector('.tab-arrow_next').classList.remove('disabled');
                
                for (var bi = 0; bi < target.closest('.tab-content').querySelectorAll('.bundle-filter:not(.active)').length; bi++) {
                    target.closest('.tab-content').querySelectorAll('.bundle-filter:not(.active) .filter-the-box')[bi].classList.add('disabled');
                    target.closest('.tab-content').querySelectorAll('.bundle-filter:not(.active) .filter-the-box')[bi].disabled = true;
                }
            } else {
                target.closest('.tab-content').querySelector('.tab-arrow_next').disabled = true;
                target.closest('.tab-content').querySelector('.tab-arrow_next').classList.add('disabled');
                for (var bi = 0; bi < target.closest('.tab-content').querySelectorAll('.bundle-filter:not(.active)').length; bi++) {
                    target.closest('.tab-content').querySelectorAll('.bundle-filter:not(.active) .filter-the-box')[bi].classList.remove('disabled');
                    target.closest('.tab-content').querySelectorAll('.bundle-filter:not(.active) .filter-the-box')[bi].disabled = false;
                }
            }
        }

        const allBundles = document.querySelectorAll('.bundle-item .add-to-box');

        // reset all bundle item
        allBundles.forEach(item => {
            item.classList.remove('remove-from-box');
            item.closest('.bundle-item').classList.remove('active');
            item.closest('.bundle-item').querySelector('select').disabled = false;
            item.innerHTML = 'Add to box';
            item.disabled = false;
            item.classList.remove('disabled');
            item.closest('.tab-content').querySelector('.tab-arrow_next').disabled = true;
            item.closest('.tab-content').querySelector('.tab-arrow_next').classList.add('disabled');
        })

        this.generateSummary();
    }

    addToBox(target) {

        if ( target.classList.contains('remove-from-box') ) {
            target.classList.remove('remove-from-box');
            target.closest('.bundle-item').classList.remove('active');
            target.closest('.bundle-item').querySelector('select').disabled = false;
            target.innerHTML = 'Add to box';
        } else {
            target.classList.add('remove-from-box');
            target.closest('.bundle-item').classList.add('active');
            target.closest('.bundle-item').querySelector('select').disabled = true;
            target.innerHTML = 'Remove from box';
        }

        let minimum = parseInt(target.closest('.tab-content').dataset.minimum);
        
        if ( minimum == 0 ) {
            target.closest('.tab-content').querySelector('.tab-arrow_next').disabled = false;
            target.closest('.tab-content').querySelector('.tab-arrow_next').classList.remove('disabled');
        } else {
            if ( target.closest('.tab-content').querySelectorAll('.bundle-item.active').length >= minimum) {
                target.closest('.tab-content').querySelector('.tab-arrow_next').disabled = false;
                target.closest('.tab-content').querySelector('.tab-arrow_next').classList.remove('disabled');
                
                for (var bi = 0; bi < target.closest('.tab-content').querySelectorAll('.bundle-item:not(.active)').length; bi++) {
                    target.closest('.tab-content').querySelectorAll('.bundle-item:not(.active) .add-to-box')[bi].classList.add('disabled');
                    target.closest('.tab-content').querySelectorAll('.bundle-item:not(.active) .add-to-box')[bi].disabled = true;
                }
            } else {
                target.closest('.tab-content').querySelector('.tab-arrow_next').disabled = true;
                target.closest('.tab-content').querySelector('.tab-arrow_next').classList.add('disabled');
                for (var bi = 0; bi < target.closest('.tab-content').querySelectorAll('.bundle-item:not(.active)').length; bi++) {
                    target.closest('.tab-content').querySelectorAll('.bundle-item:not(.active) .add-to-box')[bi].classList.remove('disabled');
                    target.closest('.tab-content').querySelectorAll('.bundle-item:not(.active) .add-to-box')[bi].disabled = false;
                }
            }
        }
        
        let summary = document.querySelectorAll('.bundle-item.active');

        let summaryItems = '';
        let summaryTitle = '';
        let summaryPrice = '';
        let summaryImage = '';
        let summaryValue = 0;

        for (var s = 0; s < summary.length; s++) {
            summaryTitle = '<br />(' + summary[s].querySelector('select').options[summary[s].querySelector('select').selectedIndex].dataset.title + ')';

            if ( summaryTitle == '<br />(Default Title)' ) {
                summaryTitle = '';
            }

            summaryImage = summary[s].querySelector('img').getAttribute('src');

            summaryPrice = summary[s].querySelector('select').options[summary[s].querySelector('select').selectedIndex].dataset.price

            if ( summary[s].classList.contains('hide-price') ) {
                summaryPrice = '';
            }

            summaryValue = parseFloat(summary[s].querySelector('select').options[summary[s].querySelector('select').selectedIndex].dataset.value) + parseFloat(summaryValue);

            summaryItems += `<li>
                <div class="grid--flex gap">
                    <img src="${summaryImage}" width="100"/>
                    <span>
                        ${summary[s].querySelector('.title').innerHTML}
                        ${summaryTitle}
                    </span>
                </div>
                <div>
                    ${summaryPrice}
                </div>
            </li>`;
        }

        document.querySelector('#bundle-box-content').innerHTML = summaryItems;

        document.querySelector('#bundle-box-subtotal span').innerHTML = summaryValue.toFixed(2) + ' ' + Shopify.currency.active;

        this.generateSummary();
    }

    generateSummary() {

        this.summarizedItem = [];
        
        const selectedFilters = this.querySelectorAll('.bundle-filter.active');

        selectedFilters.forEach(selectedFilter => {
            this.summarizedItem.push({
              "title": selectedFilter.dataset.value
            });
        });

        const selectedBundles = this.querySelectorAll('.bundle-item.active');

        selectedBundles.forEach(selectedBundles => {
            this.summarizedItem.push({
                "title": selectedBundles.querySelector('.title').textContent,
                "image": selectedBundles.querySelector('img').getAttribute('src')
            });
        });

        let summaryItem = '';
        let summaryItemImage = '';

        this.summarizedItem.forEach(item => {

            if ( item.image ) {
                summaryItemImage = '<img src="' + item.image + '" />'
            }

            summaryItem += `<li>${summaryItemImage}${item.title}</li>`;
        });

        const elsummary = document.querySelectorAll('.summary');

        elsummary.forEach(summary => {
            summary.innerHTML = summaryItem;
        });
    }

    cartBubble(count) {
        document.querySelector('#cart-icon-bubble').innerHTML = `
        <svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
            <path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path>
        </svg>
        <span class="visually-hidden">Cart</span>
        <div class="cart-count-bubble">
            <span aria-hidden="true">${count}</span>
            <span class="visually-hidden">${count} items</span>
        </div>`;
    }

    async refreshCart(reOpenCart) {
        let cartCount = 0;
        try {
            const resCart = await fetch(`${routes.cart_url}.js`);
            const dataCart = await resCart.json();

            if ( resCart.ok ) {

                cartCount = dataCart.item_count;
                this.cartBubble(dataCart.item_count);
            }

            const res = await fetch(`${routes.cart_url}?view=ajax`);
            const data = await res.text();

            if ( res.ok ) {
                document.querySelector('.drawer__inner').innerHTML = data;
                
                if ( cartCount == 0 ) {
                    document.querySelector('cart-drawer').classList.add('is-empty');
                } else {
                    document.querySelector('cart-drawer').classList.remove('is-empty');
                }
            }

            if ( resCart.ok && res.ok ) {
                if (reOpenCart == true) {
                    this.cart.open();
                    this.submitBtn.querySelector('.loading__spinner').classList.add('hidden');
                    // this.submitBtn.querySelector('span').innerHTML = "Buy Another One";
                }
            }
        }
        catch (err) {
            console.log(err);
        }
    }

    AddToCart() {
        let items = [];
        let tempItems = [];

        let variantIds = document.querySelectorAll('.bundle-item.active select');

        if (variantIds.length == 0) return;

        let props = {};
        let selectedVariants = '';
        for ( var q = 0; q < this.quantity.value; q++) {

            props = {
                "_bundleUniqueID": randomString(6),
                "_bundle_RecipientName": this.querySelector('#bundle-recipient-name').value,
                "_bundle_SenderName": this.querySelector('#bundle-sender-name').value,
                "_bundle_CardConent": this.querySelector('#bundle-card-content').value,
                "_bundle_image": this.querySelector('#bundle-info').dataset.image,
                "_bundle_title": this.querySelector('#bundle-info').dataset.title,
                "_bundle_url": this.querySelector('#bundle-info').dataset.url
            }    
            
            for ( var x = 0; x < variantIds.length; x++ ) {
                if ( variantIds[x].value ) {
                    items.push(
                        {
                            'id': variantIds[x].value,
                            'quantity': 1,
                            'properties': props
                        }
                    );

                    tempItems.push(
                        {
                            'id': variantIds[x].value,
                            'quantity': 1,
                            'properties': props
                        }
                    );
                }
            }

            selectedVariants = tempItems.map(({ id }) => id).join('|');

            props._bundleVariants = selectedVariants;

            tempItems = [];
        }

        let formData = {
            'items': items
        };

        console.log(formData);
        console.log(items);
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(response => {
            // reset Id
            props = {
                "_bundleUniqueID": randomString(6),
            }

            this.refreshCart(true);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    removeFromCart(items) {
        let variants = items.split(',');

        if (!variants) return;
        let obj = variants.reduce((o, key) => ({ ...o, [key]: 0}), {});

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({updates: obj})
        })
        .then(response => response.json())
        .then(response => {
            if ( document.querySelector('.template-cart') ) {
                location.reload();
            } else {
                this.refreshCart();
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}

customElements.define('product-bundle', Bundle);
